import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { defineComponent as _defineComponent } from 'vue';
import AzButton from '~/components/_next/atoms/AzButton.vue';
import useIsMobile from '~/composables/useIsMobile';
import { useAuthenticatedAction } from '~/composables/useAuthenticatedAction';
import { useBooxi } from '~/composables/_next/useBooxi';
import { useGetTranslations } from '~/composables/useGetTranslations';
import { useWorkshop } from '~/composables/_next/useWorkshop';
import AzIcon from '~/components/_next/atoms/AzIcon.vue';
import useShippingCountry from '@/composables/useShippingCountry';
export default /*#__PURE__*/_defineComponent({
  __name: 'MenuWorkShopItems',
  emits: ['close'],
  setup: function setup(__props, _ref) {
    var emit = _ref.emit;
    var AddToCartOverlay = function AddToCartOverlay() {
      return import('~/components/Layout/Cart/AddToCart/AddToCartOverlay.vue');
    };
    var _useShippingCountry = useShippingCountry(),
      currentCountry = _useShippingCountry.country;
    var _useUiState = useUiState(),
      toggleCartSidebar = _useUiState.toggleCartSidebar;
    var _useNuxt2App = useNuxt2App(),
      app = _useNuxt2App.app;
    var router = useRouter();
    var route = useRoute();
    var _useGetTranslations = useGetTranslations(),
      translate = _useGetTranslations.translate;
    var _useWorkshop = useWorkshop(),
      checkAndAddWorkshopToCart = _useWorkshop.checkAndAddWorkshopToCart;
    var _useBooxi = useBooxi(),
      loadBooxi = _useBooxi.loadBooxi,
      openBooxi = _useBooxi.openBooxi;
    var _useAuthenticatedActi = useAuthenticatedAction(),
      doActionOrLogin = _useAuthenticatedActi.doActionOrLogin;
    var items = ref('');
    var isAddToCartModalOpen = ref(true);
    var toggleAddToCartModal = function toggleAddToCartModal() {
      if (useIsMobile()) {
        emit('close');
        isAddToCartModalOpen.value = !isAddToCartModalOpen.value;
      }
    };
    var isFrShipping = computed(function () {
      var _currentCountry$value;
      return (currentCountry === null || currentCountry === void 0 ? void 0 : (_currentCountry$value = currentCountry.value) === null || _currentCountry$value === void 0 ? void 0 : _currentCountry$value.name) === 'FR';
    });
    function goToOurWorkShop() {
      router.push(app.localePath({
        name: 'legacy-Basic-slug',
        params: {
          slug: translate('route.workshop')
        }
      }));
    }
    function bookNow() {
      return _bookNow.apply(this, arguments);
    }
    function _bookNow() {
      _bookNow = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var _route$query, _route$query2, _route$query3;
        var bookingFlow;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return loadBooxi();
            case 2:
              bookingFlow = 'locations';
              if (((_route$query = route.query) === null || _route$query === void 0 ? void 0 : _route$query.isAccesOfAllShop) === 'false') bookingFlow = '';
              openBooxi({
                shopId: (_route$query2 = route.query) === null || _route$query2 === void 0 ? void 0 : _route$query2.shop,
                serviceTags: (_route$query3 = route.query) === null || _route$query3 === void 0 ? void 0 : _route$query3.serviceTags,
                bookingFlow: bookingFlow,
                onClose: function onClose(booxiData) {
                  if ((booxiData === null || booxiData === void 0 ? void 0 : booxiData.bookNowStatus) === 'Booked') {
                    doActionOrLogin({
                      previousRoutePath: route.path,
                      nextRoutePath: app.localePath({
                        name: 'checkout-workshop'
                      }),
                      action: function () {
                        var _action = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                          return regeneratorRuntime.wrap(function _callee$(_context) {
                            while (1) switch (_context.prev = _context.next) {
                              case 0:
                                _context.next = 2;
                                return checkAndAddWorkshopToCart(booxiData);
                              case 2:
                              case "end":
                                return _context.stop();
                            }
                          }, _callee);
                        }));
                        function action() {
                          return _action.apply(this, arguments);
                        }
                        return action;
                      }()
                    });
                  }
                }
              });
            case 5:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      return _bookNow.apply(this, arguments);
    }
    return {
      __sfc: true,
      AddToCartOverlay: AddToCartOverlay,
      emit: emit,
      currentCountry: currentCountry,
      toggleCartSidebar: toggleCartSidebar,
      app: app,
      router: router,
      route: route,
      translate: translate,
      checkAndAddWorkshopToCart: checkAndAddWorkshopToCart,
      loadBooxi: loadBooxi,
      openBooxi: openBooxi,
      doActionOrLogin: doActionOrLogin,
      items: items,
      isAddToCartModalOpen: isAddToCartModalOpen,
      toggleAddToCartModal: toggleAddToCartModal,
      isFrShipping: isFrShipping,
      goToOurWorkShop: goToOurWorkShop,
      bookNow: bookNow,
      AzButton: AzButton,
      useIsMobile: useIsMobile,
      AzIcon: AzIcon
    };
  }
});